<button class="btn"
        mat-raised-button
        *ngIf="!isLoading"
        [class.lg]="size == 'lg'"
        [class.md]="size == 'md'"
        [class.has-icon]="icon&&!iconAtLeft"
        [class.has-left-icon]="icon&&iconAtLeft"
        [disabled]="disabled"
        [color]="color"
        (click)="onClick($event)">
    <mat-icon *ngIf="icon&&iconAtLeft">
        {{icon}}
    </mat-icon>
    <ng-content></ng-content>
    <mat-icon *ngIf="icon&&!iconAtLeft">
        {{icon}}
    </mat-icon>
</button>

<ig-spinner *ngIf="isLoading"></ig-spinner>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/button/button.component.html